/* import __COLOCATED_TEMPLATE__ from './line-of-credit-balances.hbs'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import environment from '@square/environment-utils/environment';
import { action } from '@ember/object';
// eslint-disable-next-line dashboard/use-utilities-window
import theWindow from 'ember-window-mock';
const PEACH_DASHBOARD_URL = environment().isProduction ? 'https://square.peach.finance' : 'https://square-borrower.peach-sandbox.finance';
let LineOfCreditBalances = (_class = class LineOfCreditBalances extends Component {
  get peachDashboardUrl() {
    return PEACH_DASHBOARD_URL;
  }
  goToPeachDashboard() {
    theWindow.open(this.peachDashboardUrl, '_blank', 'noopener noreferrer');
  }
}, _applyDecoratedDescriptor(_class.prototype, "goToPeachDashboard", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToPeachDashboard"), _class.prototype), _class);
export { LineOfCreditBalances as default };